import { UntypedFormGroup } from "@angular/forms";

export function PasswordMatchValidator(control: string, matchingControl: string){
    return(formGroup: UntypedFormGroup) =>{
        let password = formGroup.controls[control];
        let confirmPassword = formGroup.controls[matchingControl];
        if(confirmPassword.errors && !confirmPassword.errors.passwordMatch){
            return;
        }
        if(password.value != confirmPassword.value){
            confirmPassword.setErrors({passwordMatch: true});
        }else{
            confirmPassword.setErrors(null);
        }  
    }

}